import { Component, type ErrorInfo, type ReactNode } from "react";

interface State {
  error: Error | null;
  info: ErrorInfo | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null, info: null };

  static getDerivedStateFromError(error: Error): State {
    return { error, info: null };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ error, info });
    // eslint-disable-next-line no-console
    console.error("GameView crashed:", error, info);
  }

  override render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: "100vh",
            background: "var(--bg-0)",
            color: "var(--fg-1)",
            padding: 24,
            fontFamily: "var(--font-mono)",
            fontSize: 13,
            whiteSpace: "pre-wrap",
          }}
        >
          <h2 style={{ color: "var(--red)", marginBottom: 12 }}>RENDER ERROR</h2>
          <div style={{ color: "var(--fg-1)", marginBottom: 10 }}>
            {this.state.error.name}: {this.state.error.message}
          </div>
          <div style={{ color: "var(--fg-3)" }}>{this.state.error.stack}</div>
          {this.state.info?.componentStack ? (
            <>
              <hr style={{ borderColor: "var(--line)", margin: "16px 0" }} />
              <div style={{ color: "var(--fg-3)" }}>{this.state.info.componentStack}</div>
            </>
          ) : null}
        </div>
      );
    }
    return this.props.children;
  }
}
